import { render, staticRenderFns } from "./pageBase.vue?vue&type=template&id=595a90ac&"
import script from "./pageBase.vue?vue&type=script&lang=js&"
export * from "./pageBase.vue?vue&type=script&lang=js&"
import style0 from "./pageBase.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports